/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportCreateFragmentUploadMutationRequest, SocialExportCreateFragmentUploadMutationResponse, SocialExportCreateFragmentUploadPathParams, SocialExportCreateFragmentUpload400, SocialExportCreateFragmentUpload401, SocialExportCreateFragmentUpload403, SocialExportCreateFragmentUpload404 } from "../models/SocialExportCreateFragmentUpload";

export function getSocialExportCreateFragmentUploadUrl(fragment: SocialExportCreateFragmentUploadPathParams["fragment"]) {
  const res = { method: 'POST', url: `/social-export/v1/upload/fragments/${fragment}` as const }
  return res
}

/**
 * @description Creates an upload from a fragment and queues publishing to the selected connection/platform. Deprecated: use POST /upload with a media URL source instead.
 * @summary Start upload of fragment media to a platform
 * {@link /social-export/v1/upload/fragments/:fragment}
 * @deprecated
 */
export async function socialExportCreateFragmentUpload(fragment: SocialExportCreateFragmentUploadPathParams["fragment"], data: SocialExportCreateFragmentUploadMutationRequest, config: Partial<RequestConfig<SocialExportCreateFragmentUploadMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SocialExportCreateFragmentUploadMutationResponse, ResponseErrorConfig<SocialExportCreateFragmentUpload400 | SocialExportCreateFragmentUpload401 | SocialExportCreateFragmentUpload403 | SocialExportCreateFragmentUpload404>, SocialExportCreateFragmentUploadMutationRequest>({ method : "POST", url : getSocialExportCreateFragmentUploadUrl(fragment).url.toString(), data : requestData, ... requestConfig })
  return res.data
}